import React, { useState, useEffect } from "react"
import { InputOTP, InputOTPGroup, InputOTPSeparator, InputOTPSlot } from "@/components/ui/input-otp"
import { Button } from "@/components/ui/button"
import { Label } from "@/components/ui/label"
import { Alert, AlertTitle, AlertDescription } from "@/components/ui/alert"
import { useNavigate } from "react-router-dom"

export default function TwoFactorAuth() {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [timeLeft, setTimeLeft] = useState(60);
  const [isVerified, setIsVerified] = useState(false);
  const [error, setError] = useState("");
  const [expired, setExpired] = useState(false);
  const [generatedOtp, setGeneratedOtp] = useState("123456");

  const navigate = useNavigate();

  useEffect(() => {
    const tempToken = localStorage.getItem("temp_token");
    if (!tempToken) {
      navigate("/login");
    }
  }, [navigate]);

  useEffect(() => {
    if (timeLeft === 0) {
      setExpired(true);
      return;
    }
    const timer = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft]);

  useEffect(() => {
    if (isVerified) {

      const token = "jwt_token_" + Math.random().toString(36).substring(2);
      const tempUser = JSON.parse(localStorage.getItem("temp_user") || "{}");
      
      localStorage.setItem("auth_token", token);
      localStorage.setItem("auth_user", JSON.stringify({
        ...tempUser,
        id: 1,
        name: "Demo Kullanıcı",
        role: "Admin"
      }));
      
   
      localStorage.removeItem("temp_token");
      localStorage.removeItem("temp_user");
      
    
      setTimeout(() => {
        navigate("/");
      }, 1000); 
    }
  }, [isVerified, navigate]);

  const verifyOtp = () => {
    if (expired) {
      setError("Kodun süresi doldu. Lütfen yeni bir kod isteyin.");
      return;
    }

    const userOtp = otp.join("");
    if (userOtp === generatedOtp) {
      setIsVerified(true);
      setError("");
    } else {
      setError("Geçersiz kod. Lütfen tekrar deneyin.");
    }
  };

  const handleResendCode = () => {
    // Burada aslında API'den yeni bir kod alınmalı (şu an sabit).
    setGeneratedOtp("123456"); // Aynı kod kalıyor (örnek amaçlı)
    setOtp(["", "", "", "", "", ""]);
    setTimeLeft(60);
    setExpired(false);
    setIsVerified(false);
    setError("");
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="max-w-md w-full p-8 bg-white shadow-lg rounded-lg">
        <div className="flex flex-col items-center gap-4 text-center mb-6">
          <h1 className="text-2xl font-bold">2FA Doğrulaması</h1>
          <p className="text-sm text-gray-600">
            Lütfen e-posta adresinize gönderilen doğrulama kodunu girin. Kod, 60 saniye sonra geçersiz olacaktır.
          </p>
        </div>

        <form className="flex flex-col gap-6">
          <div className="grid gap-3">
            <Label htmlFor="otp">Doğrulama Kodu</Label>
            <InputOTP value={otp.join("")} onChange={(val) => setOtp(val.split(""))} maxLength={6}>
              <InputOTPGroup>
                <InputOTPSlot index={0} />
                <InputOTPSlot index={1} />
                <InputOTPSlot index={2} />
              </InputOTPGroup>
              <InputOTPSeparator />
              <InputOTPGroup>
                <InputOTPSlot index={3} />
                <InputOTPSlot index={4} />
                <InputOTPSlot index={5} />
              </InputOTPGroup>
            </InputOTP>
          </div>

          <div>
            <p className="text-sm text-gray-500 mb-2">Kalan süre: {timeLeft} saniye</p>
            <Button type="button" variant="default" className="w-full" onClick={verifyOtp}>
              Doğrula
            </Button>
          </div>

          <div className="text-center text-sm mt-4">
            Kod almadınız mı?{" "}
            <button type="button" onClick={handleResendCode} className="text-blue-600 underline underline-offset-4 hover:underline">
              Yeni Kod Al
            </button>
          </div>

          {isVerified && (
            <Alert variant="success" className="mt-4">
              <AlertTitle>Başarılı</AlertTitle>
              <AlertDescription>Doğrulama başarılı. Ana sayfaya yönlendiriliyorsunuz...</AlertDescription>
            </Alert>
          )}

          {error && (
            <Alert variant="destructive" className="mt-4">
              <AlertTitle>Hata</AlertTitle>
              <AlertDescription>{error}</AlertDescription>
            </Alert>
          )}

          {expired && !isVerified && (
            <Alert variant="destructive" className="mt-4">
              <AlertTitle>Zaman Aşımı</AlertTitle>
              <AlertDescription>İşlem süresi doldu, lütfen tekrar deneyin.</AlertDescription>
            </Alert>
          )}
        </form>
      </div>
    </div>
  );
}
